import ConciliationRequest from '../ConciliationRequest';

export default {
  props: {
    transferId: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    requestClass: ConciliationRequest,
    swalConfig: {
      successMessage: 'Sucesso ao conciliar transação!',
      errorMessage: 'Falha ao tentar conciliar transação',
    },
    payload: {
      conciliationId: '',
      clientId: '',
      accountNumber: '',
      accountVerificationDigit: '',
      originName: '',
      originDocument: '',
      bankTransferId: '',
      observation: '',
    },
  }),
  computed: {
    getId() {
      return this.$route.params.id;
    },
    getTransferId() {
      return this.transferId;
    },
    proxyRequest() {
      return (payload) => this.requestClass.conciliation(
        this.preparePayload(payload),
      );
    },
  },
  methods: {
    preparePayload(payload) {
      return {
        ...payload,
        conciliationId: this.getId,
        bankTransferId: this.getTransferId,
        originName: this.setName(),
        originDocument: this.payload.originDocument.replace(/[^0-9]/g, ''),
      };
    },
    setName() {
      if (typeof this.payload.originName === 'string') {
        return this.payload.originName;
      }
      return this.payload.originName.text;
    },
    requestCallBack(ev) {
      this.$root.$emit('reload-ted', ev);
    },
  },
};
